import Cookies from 'js-cookie';

export interface AdbContextCookieV2 {
  readonly key: string;
  readonly adbContext: AdbContextV2;
}

export interface AdbContextV2 {
  readonly outletId: string;
  readonly referrerPath: string;
  readonly hasCustomer: boolean;
  readonly customerType?: string;
}

export function parseAdbContextCookie(
  cookieName: string,
): AdbContextCookieV2 | undefined {
  const cookieData = Cookies.get(cookieName);

  if (cookieData) {
    try {
      const value = JSON.parse(cookieData);

      return isObject(value) &&
        typeof value.key === `string` &&
        isObject(value.adbContext) &&
        typeof value.adbContext.outletId === `string` &&
        typeof value.adbContext.referrerPath === `string` &&
        typeof value.adbContext.hasCustomer === `boolean`
        ? (value as any as AdbContextCookieV2)
        : undefined;
    } catch {}
  }

  return undefined;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === `object` && value !== null;
}
